<template>
  <div class="c-content__imageBlock c-standard">
    <div class="c-content__imageBlock--image">
      <img :src="content.img" :alt="content.text[0].title">
    </div>
    <div class="c-content__imageBlock--text">
      <div v-for="(item, index) in content.text" :key="index">
        <h3 class='title_h3 relative'>
          <span>{{ item.title }}</span>
          <div class="textBgLeft absolute" style='top: 0'></div>
        </h3>
        <p>{{ item.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'imageBlock',
    props: ['content'],
    data(){
      return{

      }
    },
    computed: {

    },
    methods:{

    },
    created(){

    }
  }
</script>

<style>


</style>
